import { Dialog } from '@mui/material';

import './DeviceConfigRecommendations.scss';

type DeviceConfigRecommendationsProps = {
  isOpen: boolean;
  onClose(): void;
}
function DeviceConfigRecommendations({
  isOpen,
  onClose,
}: DeviceConfigRecommendationsProps) {
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <div className="devices-provisioning-recommendations">
        <div className="title__header">
          <h2>Creation recommendations</h2>
        </div>
        <div className="devices-provisioning-recommendations__block">
          <p className="devices-provisioning-recommendations__block--title">
            ›&nbsp;&nbsp;To upload bulk number of devices (upload csv)
            with their IPs statically defined by the user :
          </p>
          <div className="devices-provisioning-recommendations__block--list">
            <p prefix="•&nbsp;&nbsp;&nbsp;">
              Bulk-CSV upload option is <span className="recommend">recommended</span>
            </p>
            <p prefix="•&nbsp;&nbsp;&nbsp;">
              Enabling Auto-provisioning is&nbsp;
              authorized but <span className="not-recommend">NOT recommended</span>
            </p>
          </div>
        </div>
        <div className="devices-provisioning-recommendations__block">
          <p className="devices-provisioning-recommendations__block--title">
            ›&nbsp;&nbsp;If the selected SCHC Template containing :
          </p>
          <div className="devices-provisioning-recommendations__block--list">
            <div>
              <p prefix="•&nbsp;&nbsp;&nbsp;">DevIID compute function</p>
              <p prefix="•&nbsp;&nbsp;&nbsp;">Sync enabled flow and template</p>
              <div>
                <p prefix="≫">
                  Use Auto-provisioning is <span className="recommend">recommended</span>
                </p>
                <p prefix="≫">
                  Use of ways of devices provisioning like Bulk-CSV,&nbsp;
                  MultiDevice-Upload or Simple-Add is <span className="not-recommend">NOT recommended</span>
                </p>
              </div>
            </div>
            <div>
              <p prefix="•&nbsp;&nbsp;&nbsp;">
                The dynamic function like&nbsp;
                GetDeviceIP6Prefix, GetDeviceIP6IID (default templates)
              </p>
              <div>
                <p prefix="≫">Use of ways of devices provisioning like Auto-provisioning, MultiDevice-Upload or Simple-Add is <span className="recommend">recommended</span></p>
                <p prefix="≫">Use of Bulk-CSV is <span className="not-recommend">NOT recommended</span></p>
              </div>
            </div>
            <div>
              <p prefix="•&nbsp;&nbsp;&nbsp;">Static DevicePrefix and DeviceIID as target values</p>
              <div>
                <p prefix="≫">Use this template is <span className="not-recommend">NOT recommend</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default DeviceConfigRecommendations;
